import { toExternalImage } from '../lib/dropify'

export type CometMaskDefinition = {
  sku: string
  name: string
  shortName: string
  slug: string
  image: string
  layers: string
  pack: string
  material: string
  feature: string
  colors: string
  standard: string
  bfe: string | null
  akd: string | null
}

// Facts are transcribed from docs/apd/produk-comet.md, sourced from the
// official COMET catalogue from PT Alifindo Mitra Bersama.
export const COMET_MASK_DEFINITIONS: CometMaskDefinition[] = [
  {
    sku: 'COMET-THEO-3PLY',
    name: 'Masker COMET Theo 3 Ply Earloop (Box 50 Pcs)',
    shortName: 'Theo 3 Ply',
    slug: 'masker-comet-theo-3-ply-earloop-box-50-pcs',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/530a439634b44ff7a3550bf8a0ff2e10.png',
    layers: '3 ply',
    pack: '50 pcs per box',
    material: 'Melt-blown non woven dengan nose wire, bebas fiberglass',
    feature: 'Pilihan earloop dan headloop untuk penggunaan operasional harian',
    colors: 'Hijau, hitam, dan putih',
    standard: 'CE · ISO 13485',
    bfe: 'BFE 95%',
    akd: 'Kemenkes RI AKD 21603220823',
  },
  {
    sku: 'COMET-THEO-4D',
    name: 'Masker COMET Theo 4D (Box 20 Pcs)',
    shortName: 'Theo 4D',
    slug: 'masker-comet-theo-4d-box-20-pcs',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/909e7adc3a644a3cbe5ed1517dd03270.png',
    layers: '4 ply',
    pack: '20 pcs per box',
    material: 'Melt-blown non woven dengan nose wire',
    feature: 'Bentuk 4D memberi ruang di depan mulut dan membantu mengurangi embun pada kacamata',
    colors: 'Hitam, putih, abu, dan krem',
    standard: 'CE · ISO 13485',
    bfe: 'BFE 95%',
    akd: 'Kemenkes RI AKD 20903220839',
  },
  {
    sku: 'COMET-THEO-KN95',
    name: 'Masker COMET Theo KN95 (Box 20 Pcs)',
    shortName: 'Theo KN95',
    slug: 'masker-comet-theo-kn95-box-20-pcs',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/f23d771d9c18438595645ec75ba937d4.png',
    layers: '5 ply',
    pack: '20 pcs per box',
    material: 'Melt-blown non woven dan cotton dengan nose wire',
    feature: 'Model earloop dengan data BFE tertinggi dalam lini COMET Theo yang tersedia',
    colors: 'Hitam, putih, abu, dan krem',
    standard: 'CE · ISO 13485',
    bfe: 'BFE 98%',
    akd: 'Kemenkes RI AKD 20903220825',
  },
  {
    sku: 'COMET-THEO-4PLYC',
    name: 'Masker COMET Theo 4 Ply Carbon (Box 50 Pcs)',
    shortName: 'Theo 4 Ply Carbon',
    slug: 'masker-comet-theo-4-ply-carbon-box-50-pcs',
    image: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/07/23/d5b7d0f57c674a8ca74d6c6190426cb5.png',
    layers: '4 ply carbon',
    pack: '50 pcs per box',
    material: 'Polypropylene spunbond dan melt-blown non woven dengan lapisan karbon aktif',
    feature: 'Ditujukan untuk area kerja berdebu dan berbau sesuai keterangan katalog',
    colors: 'Hitam',
    standard: 'CE · ISO 13485',
    bfe: null,
    akd: null,
  },
].map((product) => ({
  ...product,
  image: toExternalImage(product.image, { width: 760, format: 'webp', quality: 76 }),
}))
